import { supabase } from '@/integrations/supabase/client';

export async function resolvePromoterPhotoUrl(photoUrl?: string | null) {
  if (!photoUrl) return null;
  let storagePath = photoUrl;

  if (photoUrl.startsWith('http://') || photoUrl.startsWith('https://')) {
    const match = photoUrl.match(/\/storage\/v1\/object\/(?:public\/)?promoter-photos\/(.+)$/);
    if (!match) {
      return photoUrl;
    }
    storagePath = decodeURIComponent(match[1]);
  }

  const { data, error } = await supabase.storage
    .from('promoter-photos')
    .createSignedUrl(storagePath, 60 * 60);

  if (error) {
    console.error('[resolvePromoterPhotoUrl] Failed to sign URL:', error);
    return null;
  }

  return data?.signedUrl ?? null;
}
